"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = { class: "mcal-root" };
var _hoisted_2 = { class: "mcal-header" };
var _hoisted_3 = { class: "mcal-header-actions" };
var _hoisted_4 = { class: "mcal-grid" };
var _hoisted_5 = { class: "mcal-col mcal-col-left" };
var _hoisted_6 = {
    key: 0,
    class: "mcal-card"
};
var _hoisted_7 = { class: "mcal-search-wrap" };
var _hoisted_8 = {
    key: 0,
    class: "mcal-search-suggestions"
};
var _hoisted_9 = ["onMousedown"];
var _hoisted_10 = { class: "mcal-suggestion-text" };
var _hoisted_11 = { class: "mcal-suggestion-name" };
var _hoisted_12 = { class: "mcal-suggestion-sub" };
var _hoisted_13 = {
    key: 0,
    class: "mcal-empty-sm"
};
var _hoisted_14 = {
    key: 1,
    class: "mcal-search-chip"
};
var _hoisted_15 = { class: "mcal-chip-name" };
var _hoisted_16 = ["label"];
var _hoisted_17 = ["value"];
var _hoisted_18 = {
    key: 1,
    class: "mcal-card"
};
var _hoisted_19 = { class: "mcal-locked-owner" };
var _hoisted_20 = {
    key: 2,
    class: "mcal-card"
};
var _hoisted_21 = { class: "mcal-card-head" };
var _hoisted_22 = { class: "mcal-timeoff-scroll" };
var _hoisted_23 = {
    key: 0,
    class: "mcal-empty-sm"
};
var _hoisted_24 = {
    key: 1,
    class: "mcal-timeoff-list"
};
var _hoisted_25 = { class: "mcal-to-text" };
var _hoisted_26 = { class: "mcal-to-name" };
var _hoisted_27 = { class: "mcal-card-sub" };
var _hoisted_28 = { class: "mcal-timeoff-scroll" };
var _hoisted_29 = {
    key: 0,
    class: "mcal-empty-sm"
};
var _hoisted_30 = {
    key: 1,
    class: "mcal-timeoff-list"
};
var _hoisted_31 = { class: "mcal-to-text" };
var _hoisted_32 = { class: "mcal-to-name" };
var _hoisted_33 = { class: "mcal-to-detail" };
var _hoisted_34 = { class: "mcal-col mcal-col-center" };
var _hoisted_35 = { class: "mcal-card mcal-calendar" };
var _hoisted_36 = { class: "mcal-cal-toolbar" };
var _hoisted_37 = { class: "mcal-nav" };
var _hoisted_38 = { class: "mcal-period" };
var _hoisted_39 = {
    class: "mcal-views",
    role: "tablist",
    "aria-label": "Calendar view"
};
var _hoisted_40 = ["aria-selected", "onClick"];
var _hoisted_41 = {
    key: 0,
    class: "mcal-scope-banner"
};
var _hoisted_42 = {
    key: 1,
    class: "mcal-month"
};
var _hoisted_43 = { class: "mcal-weekhead" };
var _hoisted_44 = { class: "mcal-month-grid" };
var _hoisted_45 = ["onClick"];
var _hoisted_46 = { class: "mcal-daynum" };
var _hoisted_47 = ["title"];
var _hoisted_48 = { class: "mcal-chips" };
var _hoisted_49 = ["onClick"];
var _hoisted_50 = { class: "mcal-chip-time" };
var _hoisted_51 = { class: "mcal-chip-title" };
var _hoisted_52 = {
    key: 0,
    class: "mcal-more"
};
var _hoisted_53 = {
    key: 2,
    class: "mcal-timeview"
};
var _hoisted_54 = { class: "mcal-tv-header week" };
var _hoisted_55 = ["onClick"];
var _hoisted_56 = { class: "dow" };
var _hoisted_57 = { class: "dnum" };
var _hoisted_58 = { class: "mcal-tv-body" };
var _hoisted_59 = { class: "mcal-tv-rail" };
var _hoisted_60 = { class: "mcal-tv-cols week" };
var _hoisted_61 = ["onClick"];
var _hoisted_62 = ["title"];
var _hoisted_63 = ["onClick"];
var _hoisted_64 = { class: "tv-ev-title" };
var _hoisted_65 = { class: "tv-ev-time" };
var _hoisted_66 = {
    key: 3,
    class: "mcal-timeview"
};
var _hoisted_67 = { class: "mcal-tv-header" };
var _hoisted_68 = { class: "dow" };
var _hoisted_69 = { class: "mcal-tv-body" };
var _hoisted_70 = { class: "mcal-tv-rail" };
var _hoisted_71 = { class: "mcal-tv-cols" };
var _hoisted_72 = ["onClick"];
var _hoisted_73 = ["title"];
var _hoisted_74 = ["onClick"];
var _hoisted_75 = { class: "tv-ev-title" };
var _hoisted_76 = { class: "tv-ev-time" };
var _hoisted_77 = { class: "tv-ev-sub" };
var _hoisted_78 = {
    key: 0,
    class: "mcal-day-empty"
};
var _hoisted_79 = { class: "mcal-legend" };
var _hoisted_80 = { key: 0 };
var _hoisted_81 = {
    key: 0,
    class: "mcal-col mcal-col-right"
};
var _hoisted_82 = { class: "mcal-card" };
var _hoisted_83 = { class: "mcal-card-head" };
var _hoisted_84 = { class: "mcal-pill" };
var _hoisted_85 = { class: "mcal-agenda-scroll" };
var _hoisted_86 = {
    key: 0,
    class: "mcal-empty-sm"
};
var _hoisted_87 = {
    key: 1,
    class: "mcal-agenda"
};
var _hoisted_88 = ["onClick"];
var _hoisted_89 = { class: "mcal-agenda-time" };
var _hoisted_90 = { class: "mcal-agenda-text" };
var _hoisted_91 = { class: "mcal-agenda-title" };
var _hoisted_92 = { class: "mcal-agenda-sub" };
var _hoisted_93 = { class: "mcal-card" };
var _hoisted_94 = { class: "mcal-agenda-scroll" };
var _hoisted_95 = {
    key: 0,
    class: "mcal-empty-sm"
};
var _hoisted_96 = {
    key: 1,
    class: "mcal-agenda upcoming"
};
var _hoisted_97 = ["onClick"];
var _hoisted_98 = { class: "mcal-agenda-text" };
var _hoisted_99 = { class: "mcal-agenda-day" };
var _hoisted_100 = { class: "mcal-agenda-title" };
var _hoisted_101 = { class: "mcal-agenda-sub" };
var _hoisted_102 = { class: "mcal-card" };
var _hoisted_103 = { class: "mcal-card-head" };
var _hoisted_104 = { class: "mcal-pill" };
var _hoisted_105 = { class: "mcal-card-sub" };
var _hoisted_106 = { class: "mcal-agenda-scroll" };
var _hoisted_107 = {
    key: 0,
    class: "mcal-empty-sm"
};
var _hoisted_108 = {
    key: 1,
    class: "mcal-parallel-list"
};
var _hoisted_109 = { class: "mcal-parallel-patient" };
var _hoisted_110 = { class: "mcal-parallel-visits" };
var _hoisted_111 = {
    class: "mcal-dialog",
    role: "dialog",
    "aria-modal": "true",
    "aria-labelledby": "mcal-ev-title"
};
var _hoisted_112 = { class: "mcal-dialog-kind" };
var _hoisted_113 = { class: "mcal-dialog-body" };
var _hoisted_114 = { id: "mcal-ev-title" };
var _hoisted_115 = { class: "mcal-detail" };
var _hoisted_116 = { key: 0 };
var _hoisted_117 = { key: 1 };
var _hoisted_118 = { class: "mcal-dialog-foot" };
var _hoisted_119 = ["disabled"];
var vue_3 = require("vue");
var patientCardsStore_1 = require("../../../stores/patientCardsStore");
var appointmentApiService_1 = require("../../../services/appointmentApiService");
var patientAvailabilityService_1 = require("../../../services/patientAvailabilityService");
var useSchedulingAccess_1 = require("@/composables/useSchedulingAccess");
var MasterCalendarBookingModal_vue_1 = require("./MasterCalendarBookingModal.vue");
var AVAILABLE_DAY_START = 7 * 60;
var AVAILABLE_DAY_END = 20 * 60;
var HOUR_START = 0;
var HOUR_END = 24;
var PX_PER_HOUR = 48;
exports.default = (0, vue_1.defineComponent)({
    __name: 'MasterCalendar',
    props: {
        accountnumber: {},
        access: {},
        showSupportingCards: { type: Boolean }
    },
    emits: ["edit-in-scheduler", "toast"],
    setup: function (__props, _a) {
        var _this = this;
        var __emit = _a.emit;
        var emit = __emit;
        var props = __props;
        var access = (0, vue_3.computed)(function () { return props.access; });
        var store = (0, patientCardsStore_1.usePatientCardsStore)();
        // Whether the "add appointment" affordance should show — admin/caregiver
        // always can; a patient/family-in-chart session only when granted.
        var canAdd = (0, vue_3.computed)(function () { var _a; return ((_a = props.access) === null || _a === void 0 ? void 0 : _a.kind) !== 'patient' || !!props.access.canAdd; });
        // The 4 supporting cards (Unavailable Blocks, Today, Upcoming, Parallel
        // Visits) are hidden by default for a patient-kind session (including a
        // caregiver viewing a patient chart without scheduling privilege) — admin
        // and plain caregiver sessions always see them. showSupportingCards is the
        // practice-wide opt-in toggled via ManageScheduling.vue's Settings gear.
        var cardsVisible = (0, vue_3.computed)(function () { var _a; return ((_a = props.access) === null || _a === void 0 ? void 0 : _a.kind) !== 'patient' || !!props.showSupportingCards; });
        // Click-to-book on empty day/week time — scoped specifically to a genuine
        // patient session (or a caregiver viewing that patient's chart) with scheduling
        // privilege. Admin and plain-caregiver sessions keep today's read-only
        // behavior unchanged (event click → "Edit in Scheduler" hand-off).
        var canInteractiveBook = (0, vue_3.computed)(function () { var _a; return ((_a = props.access) === null || _a === void 0 ? void 0 : _a.kind) === 'patient' && canAdd.value; });
        var bookingModalOpen = (0, vue_3.ref)(false);
        var bookingModalDate = (0, vue_3.ref)('');
        var bookingModalTime = (0, vue_3.ref)(undefined);
        // Set only for a Reschedule (via startReschedule below) — passed through to
        // MasterCalendarBookingModal as edit-event; null means "New Appointment".
        var editingEvent = (0, vue_3.ref)(null);
        function openBookingModal(iso, hour) {
            editingEvent.value = null;
            bookingModalDate.value = iso;
            bookingModalTime.value = "".concat(String(hour).padStart(2, '0'), ":00");
            bookingModalOpen.value = true;
        }
        // "New Appointment" header button, patient flow — no specific slot clicked,
        // so leave the time unset and let the modal default to the closest
        // available slot to now (same smart-default as clicking a slot directly).
        function openBookingModalToday() {
            editingEvent.value = null;
            bookingModalDate.value = todayIso;
            bookingModalTime.value = undefined;
            bookingModalOpen.value = true;
        }
        // Reschedule — reopens the same booking modal pre-filled from the clicked
        // event, with Caregiver/Context locked (see MasterCalendarBookingModal).
        function startReschedule(ev) {
            closeEvent();
            editingEvent.value = ev;
            bookingModalDate.value = ev.date;
            bookingModalTime.value = undefined;
            bookingModalOpen.value = true;
        }
        var cancellingVisit = (0, vue_3.ref)(false);
        function cancelActiveVisit() {
            return __awaiter(this, void 0, void 0, function () {
                var res;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!activeEvent.value)
                                return [2 /*return*/];
                            cancellingVisit.value = true;
                            return [4 /*yield*/, store.cancelAppointment(activeEvent.value.id)];
                        case 1:
                            res = _a.sent();
                            cancellingVisit.value = false;
                            if (!res.success)
                                return [2 /*return*/];
                            closeEvent();
                            emit('toast', 'Visit cancelled');
                            return [2 /*return*/];
                    }
                });
            });
        }
        function onVisitSaved() {
            return __awaiter(this, void 0, void 0, function () {
                var wasReschedule;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            wasReschedule = !!editingEvent.value;
                            return [4 /*yield*/, store.loadAppointmentsForPatients()];
                        case 1:
                            _a.sent();
                            emit('toast', wasReschedule ? 'Visit rescheduled' : 'Visit scheduled');
                            return [2 /*return*/];
                    }
                });
            });
        }
        (0, vue_3.onMounted)(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // patients/appointments are identity-scoped (whoever is currently logged
                    // in) and MUST be refetched fresh on every mount — logging out and back in
                    // as a different user never reloads the page (no location.reload anywhere
                    // in the login flow), so this Pinia store's arrays from a PREVIOUS user's
                    // session would otherwise still be sitting here non-empty, and a stale
                    // "already loaded" guard would skip reloading for the new identity
                    // entirely, silently showing the wrong (or no) data.
                    return [4 /*yield*/, store.loadPatientsFromStaffPatientsGroup()];
                    case 1:
                        // patients/appointments are identity-scoped (whoever is currently logged
                        // in) and MUST be refetched fresh on every mount — logging out and back in
                        // as a different user never reloads the page (no location.reload anywhere
                        // in the login flow), so this Pinia store's arrays from a PREVIOUS user's
                        // session would otherwise still be sitting here non-empty, and a stale
                        // "already loaded" guard would skip reloading for the new identity
                        // entirely, silently showing the wrong (or no) data.
                        _a.sent();
                        if (!(store.providers.length === 0)) return [3 /*break*/, 3];
                        return [4 /*yield*/, store.loadProviders()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        if (!(store.nurses.length === 0)) return [3 /*break*/, 5];
                        return [4 /*yield*/, store.loadNurses()];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [4 /*yield*/, store.loadAppointmentsForPatients()];
                    case 6:
                        _a.sent();
                        return [4 /*yield*/, loadAllTimeOff()];
                    case 7:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        /* ---------- Events — computed straight from the already-loaded store ---------- */
        function toMinutes(time) {
            var _a = time.split(':').map(Number), h = _a[0], m = _a[1];
            return h * 60 + m;
        }
        function caregiverInfo(providerId) {
            var p = store.providers.find(function (x) { return x.id === providerId; });
            if (p)
                return { name: p.name, category: p.category || 'provider' };
            var n = store.nurses.find(function (x) { return x.id === providerId; });
            if (n)
                return { name: n.name, category: n.category || 'nurse' };
            return { name: '', category: 'provider' };
        }
        function patientNameFor(patientId) {
            var _a;
            var p = store.patients.find(function (x) { return x.id === patientId || x.psersonalID === patientId; });
            if (p)
                return "".concat(p.firstName, " ").concat(p.lastName);
            // A genuine patient session never appears in store.patients (staff-scoped)
            // — fall back to their own session name for their own appointments.
            if (((_a = props.access) === null || _a === void 0 ? void 0 : _a.kind) === 'patient' && props.access.patientId === patientId)
                return props.access.patientName;
            return '';
        }
        var events = (0, vue_3.computed)(function () {
            return store.appointments
                .filter(function (a) { return a.status !== 'cancelled'; })
                .flatMap(function (a) {
                var _a;
                var _b = caregiverInfo(a.providerId), caregiverName = _b.name, caregiverCategory = _b.category;
                var pName = patientNameFor(a.patientId);
                var startMin = toMinutes(a.time);
                var endMin = startMin + ((_a = a.durationMinutes) !== null && _a !== void 0 ? _a : 60);
                var kind = a.meetingType === 'Telehealth' ? 'telehealth' : 'visit';
                var base = {
                    id: a.id,
                    // Patient view already knows whose chart this is — repeating the
                    // patient's own name on every event is redundant there, so it shows
                    // the caregiver + visit type instead. Admin/caregiver sessions keep
                    // patient name first, since that's the relevant "who am I seeing" info.
                    title: isPatientView.value
                        ? "".concat(caregiverName || 'Caregiver', " \u00B7 Visit Type: ").concat(a.meetingType)
                        : "".concat(pName || 'Patient', " \u00B7 ").concat(a.meetingType),
                    kind: kind,
                    patientId: a.patientId || null,
                    patientName: pName || null,
                    caregiverId: a.providerId,
                    caregiverName: caregiverName,
                    caregiverCategory: caregiverCategory,
                    context: a.meetingType,
                    location: a.meetingType,
                    reason: a.reason
                };
                // A visit that runs past midnight (e.g. a night-shift booking) is filed
                // under exactly one `date` elsewhere in this component (eventsFor does
                // an exact e.date === iso match), so a single event with endMin > 1440
                // would only ever render on its start day and overflow/clip there.
                // Split it into two events instead — one ending at midnight on the
                // start day, one starting at midnight on the next day — same shape as
                // how the (now-unnecessary) manual two-row availability workaround
                // used to render.
                if (endMin > 1440) {
                    var nextDate = isoOf(addDays(new Date(a.date + 'T00:00:00'), 1));
                    return [
                        __assign(__assign({}, base), { date: a.date, startMin: startMin, endMin: 1440 }),
                        __assign(__assign({}, base), { id: "".concat(a.id, "-next"), date: nextDate, startMin: 0, endMin: endMin - 1440 })
                    ];
                }
                return [__assign(__assign({}, base), { date: a.date, startMin: startMin, endMin: endMin })];
            });
        });
        /* ---------- Owner (My Calendars) ---------- */
        var ownerSegments = [
            { key: 'provider', label: 'Providers', icon: 'glyphicon-plus-sign' },
            { key: 'allied', label: 'Allied Professionals', icon: 'glyphicon-check' },
            { key: 'nurse', label: 'Nurses', icon: 'glyphicon-heart' },
            { key: 'hha', label: 'HHA', icon: 'glyphicon-home' },
            { key: 'patient', label: 'Patients', icon: 'glyphicon-user' }
        ];
        var ownerCategory = (0, vue_3.ref)('provider');
        var selectedOwnerId = (0, vue_3.ref)('');
        var personSearch = (0, vue_3.ref)('');
        function ownersFor(cat) {
            if (cat === 'patient') {
                return store.patients.map(function (p) { return ({
                    id: p.id,
                    name: "".concat(p.firstName, " ").concat(p.lastName),
                    sub: p.mrn
                }); });
            }
            var pool = cat === 'nurse' || cat === 'hha' ? store.nurses : store.providers;
            // filterStaffForAccess narrows this to just the caller for a locked
            // caregiver session -- see its own header for why this is centralized
            // rather than checked ad hoc here.
            return (0, useSchedulingAccess_1.filterStaffForAccess)(pool.filter(function (s) { return s.category === cat; }), props.access).map(function (s) { return ({ id: s.id, name: s.name, sub: s.specialty }); });
        }
        var owners = (0, vue_3.computed)(function () {
            var list = ownersFor(ownerCategory.value);
            var q = personSearch.value.trim().toLowerCase();
            if (!q)
                return list;
            return list.filter(function (o) { return o.name.toLowerCase().includes(q) || o.sub.toLowerCase().includes(q); });
        });
        var activeSegmentLabel = (0, vue_3.computed)(function () { var _a; return ((_a = ownerSegments.find(function (s) { return s.key === ownerCategory.value; })) === null || _a === void 0 ? void 0 : _a.label) || ''; });
        // Same search-filtered rows as `owners`, but for an arbitrary category — the
        // dropdown renders every segment's optgroup at once, so each one filters
        // independently against the shared search box instead of a single active segment.
        function ownersForFiltered(cat) {
            var list = ownersFor(cat);
            var q = personSearch.value.trim().toLowerCase();
            if (!q)
                return list;
            return list.filter(function (o) { return o.name.toLowerCase().includes(q) || o.sub.toLowerCase().includes(q); });
        }
        // Dropdown's selected value is `${category}::${id}` so one <select> can encode
        // both which segment an option belongs to and which row within it — picking an
        // option sets ownerCategory + selectedOwnerId together, exactly like segment +
        // person click used to, so scopedEvents/displayedTimeOff/patientBlocks/
        // parallelVisitsToday all resolve the same way they did with the old button UI.
        var ownerDropdownValue = (0, vue_3.computed)({
            get: function () { return (selectedOwnerId.value ? "".concat(ownerCategory.value, "::").concat(selectedOwnerId.value) : ''); },
            set: function (val) {
                if (!val) {
                    selectedOwnerId.value = '';
                    return;
                }
                var sepIdx = val.indexOf('::');
                ownerCategory.value = val.slice(0, sepIdx);
                selectedOwnerId.value = val.slice(sepIdx + 2);
            }
        });
        var selectedOwner = (0, vue_3.computed)(function () {
            if (!selectedOwnerId.value)
                return null;
            for (var _i = 0, ownerSegments_1 = ownerSegments; _i < ownerSegments_1.length; _i++) {
                var seg = ownerSegments_1[_i];
                var hit = ownersFor(seg.key).find(function (o) { return o.id === selectedOwnerId.value; });
                if (hit)
                    return hit;
            }
            return null;
        });
        /* ---------- Search-box autocomplete (Outlook/Gmail-style token field) ----------
         * Typing shows a fuzzy-matched picker across every segment at once (the plain
         * text box gave no feedback that anything was matching); picking a result sets
         * the same ownerCategory + selectedOwnerId the dropdown does, so the <select>
         * updates in lockstep. Once picked, the input is replaced by a removable name
         * chip — clicking its "x" clears the selection and returns to the search box. */
        var searchSuggestions = (0, vue_3.computed)(function () {
            var q = personSearch.value.trim().toLowerCase();
            if (!q)
                return [];
            var results = [];
            for (var _i = 0, ownerSegments_2 = ownerSegments; _i < ownerSegments_2.length; _i++) {
                var seg = ownerSegments_2[_i];
                for (var _a = 0, _b = ownersFor(seg.key); _a < _b.length; _a++) {
                    var o = _b[_a];
                    if (o.name.toLowerCase().includes(q) || o.sub.toLowerCase().includes(q)) {
                        results.push({ key: "".concat(seg.key, "::").concat(o.id), category: seg.key, id: o.id, name: o.name, sub: o.sub, segLabel: seg.label });
                    }
                }
            }
            return results.slice(0, 8);
        });
        function pickSuggestion(s) {
            ownerDropdownValue.value = s.key;
            personSearch.value = '';
        }
        function clearOwnerSelection() {
            selectedOwnerId.value = '';
            personSearch.value = '';
        }
        function selectSegment(key) {
            if (key === ownerCategory.value)
                return;
            ownerCategory.value = key;
            // Clear any prior selection and search: an owner id from another segment (e.g. a
            // patient) would otherwise leak in and wrongly filter the calendar / Time Off card.
            selectedOwnerId.value = '';
            personSearch.value = '';
        }
        function selectOwner(id) {
            selectedOwnerId.value = selectedOwnerId.value === id ? '' : id;
        }
        // Lock the "My Calendars" owner selection once access resolves (async, from
        // the parent's useSchedulingAccess()) — patients/caregivers see only their
        // own calendar, no owner picker. Appointment.patientId is keyed by `mid`
        // (see patientCardsStore.ts loadAppointmentsForPatients), while access.patientId
        // is the patient's own externId/psersonalID scheme — resolve the mid via the
        // already-loaded patients list (same join store.patients already provides).
        (0, vue_3.watch)(function () { return props.access; }, function (a) { return __awaiter(_this, void 0, void 0, function () {
            var self;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!a)
                            return [2 /*return*/];
                        if (a.kind === 'caregiver') {
                            ownerCategory.value = a.category;
                            selectedOwnerId.value = a.staffId;
                            return [2 /*return*/];
                        }
                        if (!(a.kind === 'patient')) return [3 /*break*/, 3];
                        if (!(store.patients.length === 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, store.loadPatientsFromStaffPatientsGroup()];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        self = store.patients.find(function (p) { return p.psersonalID === a.patientId || p.id === a.patientId; });
                        ownerCategory.value = 'patient';
                        selectedOwnerId.value = (_a = self === null || self === void 0 ? void 0 : self.id) !== null && _a !== void 0 ? _a : a.patientId;
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); }, { immediate: true });
        /* ---------- Event filtering by selected owner ---------- */
        var scopedEvents = (0, vue_3.computed)(function () {
            if (!selectedOwnerId.value)
                return events.value;
            if (ownerCategory.value === 'patient') {
                return events.value.filter(function (e) { return e.patientId === selectedOwnerId.value; });
            }
            return events.value.filter(function (e) { return e.caregiverId === selectedOwnerId.value; });
        });
        /* ---------- Time off — aggregated client-side across every loaded caregiver ---------- */
        var timeOff = (0, vue_3.ref)([]);
        function loadAllTimeOff() {
            return __awaiter(this, void 0, void 0, function () {
                var staff, results;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            staff = (0, useSchedulingAccess_1.filterStaffForAccess)(__spreadArray(__spreadArray([], store.providers, true), store.nurses, true), props.access);
                            return [4 /*yield*/, Promise.all(staff.map(function (s) { return __awaiter(_this, void 0, void 0, function () {
                                    var rows;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, (0, appointmentApiService_1.getTimeOff)(props.accountnumber, s.id)];
                                            case 1:
                                                rows = _a.sent();
                                                return [2 /*return*/, rows.map(function (r) { return ({
                                                        id: r.id,
                                                        caregiverId: s.id,
                                                        caregiverName: s.name,
                                                        caregiverCategory: s.category || 'provider',
                                                        date: r.offDate,
                                                        allDay: !r.startTime,
                                                        startMin: r.startTime ? toMinutes(r.startTime) : null,
                                                        endMin: r.endTime ? toMinutes(r.endTime) : null,
                                                        reason: r.reason
                                                    }); })];
                                        }
                                    });
                                }); }))];
                        case 1:
                            results = _a.sent();
                            timeOff.value = results.flat().filter(function (t) { return t.date >= todayIso; });
                            return [2 /*return*/];
                    }
                });
            });
        }
        var showTimeOffOverlay = (0, vue_3.ref)(false);
        var displayedTimeOff = (0, vue_3.computed)(function () {
            var base = selectedOwner.value && ownerCategory.value !== 'patient'
                ? timeOff.value.filter(function (t) { return t.caregiverId === selectedOwnerId.value; })
                : timeOff.value;
            return __spreadArray([], base, true).sort(function (a, b) { return a.date.localeCompare(b.date); });
        });
        function timedTimeOffFor(iso) {
            if (!showTimeOffOverlay.value)
                return [];
            return displayedTimeOff.value.filter(function (t) { return t.date === iso && !t.allDay && t.startMin != null && t.endMin != null; });
        }
        function timeOffForDay(iso) {
            return displayedTimeOff.value.filter(function (t) { return t.date === iso; });
        }
        /* ---------- Patient unavailable blocks ----------
         * When a patient is selected, the Time Off card flips to show that patient's
         * authored unavailable blocks (from Patient Availability) instead of caregiver
         * time off. Blocks are fetched on demand as the selection changes. */
        var patientBlocks = (0, vue_3.ref)([]);
        // "Available Time" — the complement of today's applicable blocks within a
        // sensible daytime window (7 AM-8 PM). Patient view only; per stakeholder
        // feedback, leading with what's UNAVAILABLE reads backwards to a patient —
        // they want to know when they're open for a visit, not when they're not.
        var patientAvailableToday = (0, vue_3.computed)(function () {
            var dow = new Date(todayIso + 'T00:00:00').getDay();
            var busy = patientBlocks.value
                .filter(function (b) { return b.repeat === 'daily' || (b.repeat === 'weekly' && b.dayOfWeek === dow) || (b.repeat === 'one-time' && b.date === todayIso); })
                .map(function (b) { return ({ start: toMinutes(b.startTime), end: toMinutes(b.endTime) }); })
                .sort(function (a, b) { return a.start - b.start; });
            var gaps = [];
            var cursor = AVAILABLE_DAY_START;
            for (var _i = 0, busy_1 = busy; _i < busy_1.length; _i++) {
                var b = busy_1[_i];
                if (b.start > cursor)
                    gaps.push({ start: cursor, end: Math.min(b.start, AVAILABLE_DAY_END) });
                cursor = Math.max(cursor, b.end);
                if (cursor >= AVAILABLE_DAY_END)
                    break;
            }
            if (cursor < AVAILABLE_DAY_END)
                gaps.push({ start: cursor, end: AVAILABLE_DAY_END });
            return gaps.filter(function (g) { return g.end > g.start; });
        });
        // True for a genuine patient session viewing their own calendar (regardless
        // of whether store.patients — staff-scoped, always empty for a real patient
        // login — happens to resolve them), or for an admin who's picked a specific
        // patient from the "My Calendars" dropdown (store.patients IS populated then).
        var isPatientView = (0, vue_3.computed)(function () { var _a; return ((_a = props.access) === null || _a === void 0 ? void 0 : _a.kind) === 'patient' || (ownerCategory.value === 'patient' && !!selectedOwner.value); });
        // Shared with the "My Calendar" locked-owner label — falls back to
        // access.patientName since a real patient session never appears in the
        // staff-scoped store.patients list that selectedOwner resolves against.
        var ownerDisplayName = (0, vue_3.computed)(function () { var _a, _b; return ((_a = selectedOwner.value) === null || _a === void 0 ? void 0 : _a.name) || (((_b = props.access) === null || _b === void 0 ? void 0 : _b.kind) === 'patient' ? props.access.patientName : ''); });
        (0, vue_3.watch)(function () { return (ownerCategory.value === 'patient' ? selectedOwnerId.value : ''); }, function (patientId) { return __awaiter(_this, void 0, void 0, function () {
            var realId, rows;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!patientId) {
                            patientBlocks.value = [];
                            return [2 /*return*/];
                        }
                        realId = ((_a = props.access) === null || _a === void 0 ? void 0 : _a.kind) === 'patient'
                            ? patientId
                            : (((_b = store.patients.find(function (p) { return p.id === patientId; })) === null || _b === void 0 ? void 0 : _b.psersonalID) || patientId);
                        return [4 /*yield*/, (0, patientAvailabilityService_1.getPatientBlocks)(props.accountnumber, realId, 'in_home')];
                    case 1:
                        rows = _c.sent();
                        patientBlocks.value = rows.map(function (b) { return ({
                            id: String(b.id),
                            startTime: b.start_time.slice(0, 5),
                            endTime: b.end_time.slice(0, 5),
                            context: b.context_label,
                            hard: b.exclusivity === 'hard',
                            repeat: b.recurrence_type === 'none' ? 'one-time' : b.recurrence_type,
                            dayOfWeek: b.recurrence_day,
                            date: b.specific_date,
                            note: b.notes
                        }); });
                        return [2 /*return*/];
                }
            });
        }); }, { immediate: true });
        var blockWeekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        function blockRepeatLabel(b) {
            var _a;
            switch (b.repeat) {
                case 'daily': return 'Repeats daily';
                case 'weekly': return "Weekly \u00B7 ".concat(blockWeekdays[(_a = b.dayOfWeek) !== null && _a !== void 0 ? _a : 0]);
                default: return b.date || 'One-time';
            }
        }
        // "13:30" -> "1:30 PM"
        function fmtClock(hhmm) {
            var _a = hhmm.split(':').map(Number), h = _a[0], m = _a[1];
            return fmtTime(h * 60 + m);
        }
        /* ---------- View + navigation ---------- */
        var view = (0, vue_3.ref)('month');
        var cursor = (0, vue_3.ref)(new Date());
        cursor.value.setHours(0, 0, 0, 0);
        var todayIso = isoOf(new Date());
        var cursorIso = (0, vue_3.computed)(function () { return isoOf(cursor.value); });
        var weekdayLabels = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        function isoOf(d) {
            return "".concat(d.getFullYear(), "-").concat(String(d.getMonth() + 1).padStart(2, '0'), "-").concat(String(d.getDate()).padStart(2, '0'));
        }
        function addDays(d, n) {
            var x = new Date(d);
            x.setDate(x.getDate() + n);
            return x;
        }
        function startOfWeek(d) {
            var x = new Date(d);
            x.setDate(x.getDate() - x.getDay());
            x.setHours(0, 0, 0, 0);
            return x;
        }
        function navigate(dir) {
            var d = new Date(cursor.value);
            if (view.value === 'month')
                d.setMonth(d.getMonth() + dir);
            else if (view.value === 'week')
                d.setDate(d.getDate() + dir * 7);
            else
                d.setDate(d.getDate() + dir);
            cursor.value = d;
        }
        function goToday() {
            var d = new Date();
            d.setHours(0, 0, 0, 0);
            cursor.value = d;
        }
        function drillToDay(iso) {
            var _a = iso.split('-').map(Number), y = _a[0], m = _a[1], dd = _a[2];
            cursor.value = new Date(y, m - 1, dd);
            view.value = 'day';
        }
        var periodLabel = (0, vue_3.computed)(function () {
            var d = cursor.value;
            if (view.value === 'month') {
                return d.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
            }
            if (view.value === 'week') {
                var s = startOfWeek(d);
                var e = addDays(s, 6);
                var sameMonth = s.getMonth() === e.getMonth();
                var sLabel = s.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
                var eLabel = sameMonth
                    ? e.toLocaleDateString('en-US', { day: 'numeric' })
                    : e.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
                return "".concat(sLabel, " \u2013 ").concat(eLabel, ", ").concat(e.getFullYear());
            }
            return d.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' });
        });
        var dayHeadLabel = (0, vue_3.computed)(function () { return cursor.value.toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' }); });
        /* ---------- Month cells ---------- */
        var monthCells = (0, vue_3.computed)(function () {
            var first = new Date(cursor.value.getFullYear(), cursor.value.getMonth(), 1);
            var gridStart = startOfWeek(first);
            var cells = [];
            for (var i = 0; i < 42; i++) {
                var d = addDays(gridStart, i);
                var iso = isoOf(d);
                cells.push({
                    iso: iso,
                    dayNum: d.getDate(),
                    inMonth: d.getMonth() === cursor.value.getMonth(),
                    isToday: iso === todayIso,
                    events: eventsFor(iso),
                    timeOff: timeOffForDay(iso)
                });
            }
            return cells;
        });
        /* ---------- Week days ---------- */
        var weekDays = (0, vue_3.computed)(function () {
            var s = startOfWeek(cursor.value);
            return Array.from({ length: 7 }, function (_, i) {
                var d = addDays(s, i);
                var iso = isoOf(d);
                return { iso: iso, dow: weekdayLabels[d.getDay()], dayNum: d.getDate(), isToday: iso === todayIso };
            });
        });
        function eventsFor(iso) {
            return scopedEvents.value
                .filter(function (e) { return e.date === iso; })
                .sort(function (a, b) { return a.startMin - b.startMin; });
        }
        /* ---------- Time grid geometry ---------- */
        // Full 24h (00:00–24:00) so overnight shifts/visits (e.g. 7pm–7am) are fully
        // visible instead of clipped at the edges of a daytime-only window.
        var hourRange = Array.from({ length: HOUR_END - HOUR_START + 1 }, function (_, i) { return HOUR_START + i; });
        function blockStyle(startMin, endMin) {
            var top = ((startMin - HOUR_START * 60) / 60) * PX_PER_HOUR;
            var height = Math.max(((endMin - startMin) / 60) * PX_PER_HOUR, 22);
            return { top: "".concat(top, "px"), height: "".concat(height, "px") };
        }
        /* ---------- Overlap layout (Google-style cascade) ----------
         * Timed events that share the same day+time would otherwise stack on top of
         * each other and clip. We group each day's events into clusters of transitively
         * overlapping events, assign every event the first free "column", then cascade
         * the columns: each column is offset slightly to the right and stacked above the
         * previous one (higher z-index) so the leading edge + title of every event stays
         * visible — exactly the parallel HHA/provider case. Single (non-overlapping)
         * events keep the default full-width styling, so nothing regresses. */
        function laidOutEventsFor(iso) {
            var evs = eventsFor(iso); // already sorted by startMin
            var n = evs.length;
            var cols = new Array(n).fill(0);
            var clusterOf = new Array(n).fill(0);
            var colEnds = [];
            var clusterId = -1;
            var clusterEnd = -1;
            var _loop_1 = function (i) {
                var e = evs[i];
                if (e.startMin >= clusterEnd) {
                    clusterId++;
                    colEnds.length = 0;
                    clusterEnd = e.endMin;
                }
                else {
                    clusterEnd = Math.max(clusterEnd, e.endMin);
                }
                clusterOf[i] = clusterId;
                var placed = colEnds.findIndex(function (end) { return end <= e.startMin; });
                if (placed === -1) {
                    placed = colEnds.length;
                    colEnds.push(e.endMin);
                }
                else {
                    colEnds[placed] = e.endMin;
                }
                cols[i] = placed;
            };
            for (var i = 0; i < n; i++) {
                _loop_1(i);
            }
            var clusterCols = {};
            for (var i = 0; i < n; i++) {
                clusterCols[clusterOf[i]] = Math.max(clusterCols[clusterOf[i]] || 0, cols[i] + 1);
            }
            return evs.map(function (ev, i) {
                var maxCols = clusterCols[clusterOf[i]];
                var geo = blockStyle(ev.startMin, ev.endMin);
                if (maxCols <= 1) {
                    return { ev: ev, style: geo, overlap: false };
                }
                var offset = Math.min(16, 55 / (maxCols - 1));
                var left = cols[i] * offset;
                var zIndex = ev.id === focusedEventId.value ? 50 : cols[i] + 2;
                return {
                    ev: ev,
                    overlap: true,
                    style: __assign(__assign({}, geo), { left: "".concat(left, "%"), right: 'auto', width: "calc(".concat(100 - left, "% - 4px)"), zIndex: String(zIndex) })
                };
            });
        }
        /* ---------- Agenda (Today / Upcoming) ---------- */
        var todayEvents = (0, vue_3.computed)(function () {
            return scopedEvents.value.filter(function (e) { return e.date === todayIso; }).sort(function (a, b) { return a.startMin - b.startMin; });
        });
        var upcomingEvents = (0, vue_3.computed)(function () {
            var end = isoOf(addDays(new Date(), 10));
            return scopedEvents.value
                .filter(function (e) { return e.date > todayIso && e.date <= end; })
                .sort(function (a, b) { return (a.date === b.date ? a.startMin - b.startMin : a.date.localeCompare(b.date)); })
                .slice(0, 12);
        });
        /* ---------- Parallel Visits Today ----------
         * Groups today's (non-cancelled) events by patient, then within each patient's
         * events finds clusters of genuinely time-overlapping visits (2+ different
         * caregivers seeing the same patient at overlapping times) — not just "two
         * visits same day." Scoped the same way Today/Upcoming are: no selection shows
         * every situation practice-wide; selecting an owner filters to ones involving them. */
        var parallelVisitsToday = (0, vue_3.computed)(function () {
            var todays = events.value.filter(function (e) { return e.date === todayIso && e.patientId; });
            var byPatient = new Map();
            todays.forEach(function (e) {
                var pid = e.patientId;
                if (!byPatient.has(pid))
                    byPatient.set(pid, []);
                byPatient.get(pid).push(e);
            });
            var groups = [];
            byPatient.forEach(function (evs, patientId) {
                if (evs.length < 2)
                    return;
                var sorted = __spreadArray([], evs, true).sort(function (a, b) { return a.startMin - b.startMin; });
                var cluster = [sorted[0]];
                var clusterEnd = sorted[0].endMin;
                var flush = function () {
                    if (cluster.length >= 2) {
                        groups.push({
                            patientId: patientId,
                            patientName: cluster[0].patientName || '',
                            visits: cluster.map(function (c) { return ({ caregiverId: c.caregiverId, caregiverName: c.caregiverName, startMin: c.startMin, endMin: c.endMin }); })
                        });
                    }
                };
                for (var i = 1; i < sorted.length; i++) {
                    var e = sorted[i];
                    if (e.startMin < clusterEnd) {
                        cluster.push(e);
                        clusterEnd = Math.max(clusterEnd, e.endMin);
                    }
                    else {
                        flush();
                        cluster = [e];
                        clusterEnd = e.endMin;
                    }
                }
                flush();
            });
            if (!selectedOwnerId.value)
                return groups;
            if (ownerCategory.value === 'patient') {
                return groups.filter(function (g) { return g.patientId === selectedOwnerId.value; });
            }
            return groups.filter(function (g) { return g.visits.some(function (v) { return v.caregiverId === selectedOwnerId.value; }); });
        });
        /* ---------- Detail modal + edit routing ---------- */
        var activeEvent = (0, vue_3.ref)(null);
        // Last-clicked overlapping event — raised above its cluster neighbors
        // (Google-style bring-to-front) only while its modal is open. Reset on close so
        // the cascade returns to its default stacking and every event is reachable again.
        var focusedEventId = (0, vue_3.ref)(null);
        function openEvent(ev) {
            focusedEventId.value = ev.id;
            activeEvent.value = ev;
        }
        function closeEvent() {
            activeEvent.value = null;
            focusedEventId.value = null;
        }
        function editInScheduler(ev) {
            closeEvent();
            emit('edit-in-scheduler', ev);
        }
        function openScheduler(ev) {
            emit('edit-in-scheduler', ev);
        }
        function printCalendar() {
            window.print();
        }
        /* ---------- Formatting ---------- */
        function fmtTime(min) {
            var h = Math.floor(min / 60);
            var m = min % 60;
            var ampm = h >= 12 ? 'PM' : 'AM';
            h = h % 12 || 12;
            return m === 0 ? "".concat(h, ":00 ").concat(ampm) : "".concat(h, ":").concat(String(m).padStart(2, '0'), " ").concat(ampm);
        }
        function fmtHour(h) {
            var ampm = h >= 12 ? 'PM' : 'AM';
            var hh = h % 12 || 12;
            return "".concat(hh, " ").concat(ampm);
        }
        function shortDate(iso) {
            var _a = iso.split('-').map(Number), y = _a[0], m = _a[1], d = _a[2];
            return new Date(y, m - 1, d).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
        }
        function longDate(iso) {
            var _a = iso.split('-').map(Number), y = _a[0], m = _a[1], d = _a[2];
            return new Date(y, m - 1, d).toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' });
        }
        function relDay(iso) {
            var _a = iso.split('-').map(Number), y = _a[0], m = _a[1], d = _a[2];
            var date = new Date(y, m - 1, d);
            var diff = Math.round((date.getTime() - new Date(todayIso).getTime()) / 86400000);
            if (diff === 1)
                return 'Tomorrow';
            return date.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
        }
        function kindLabel(kind) {
            return kind === 'telehealth' ? 'Telehealth' : 'In-Person Visit';
        }
        /* ---------- Avatars ---------- */
        var AVATAR_COLORS = ['#3b82f6', '#0ea5e9', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#ec4899', '#14b8a6', '#f97316', '#6366f1'];
        function colorFor(name) {
            var hash = 0;
            for (var i = 0; i < name.length; i++)
                hash = name.charCodeAt(i) + ((hash << 5) - hash);
            return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
        }
        function initials(name) {
            var _a, _b;
            var clean = name.replace(/,.*$/, '').trim();
            var parts = clean.split(/\s+/).filter(function (p) { return !/^(dr\.?|mr\.?|mrs\.?|ms\.?)$/i.test(p); });
            var a = ((_a = parts[0]) === null || _a === void 0 ? void 0 : _a[0]) || '';
            var b = ((_b = parts[1]) === null || _b === void 0 ? void 0 : _b[0]) || '';
            return (a + b).toUpperCase();
        }
        /* ---------- Event coloring ----------
         * Reuses the same name → color hash as the "My Calendars" avatars, so an
         * event on the grid always matches the assigned caregiver's profile color —
         * letting overlapping events be told apart by caregiver at a glance instead
         * of all rendering as one indistinguishable color. */
        function eventColor(ev) {
            return colorFor(ev.caregiverName);
        }
        // Opaque pastel (color mixed with white) rather than an alpha-transparent fill —
        // cascaded/overlapping cards need a solid background or their translucent edges
        // blend into each other, muddying the boundary between stacked events.
        function tint(hex, amount) {
            if (amount === void 0) { amount = 0.85; }
            var h = hex.replace('#', '');
            var r = parseInt(h.slice(0, 2), 16);
            var g = parseInt(h.slice(2, 4), 16);
            var b = parseInt(h.slice(4, 6), 16);
            var mix = function (c) { return Math.round(c + (255 - c) * amount); };
            return "rgb(".concat(mix(r), ", ").concat(mix(g), ", ").concat(mix(b), ")");
        }
        function eventStyle(ev) {
            var color = eventColor(ev);
            return { borderLeftColor: color, background: tint(color) };
        }
        return function (_ctx, _cache) {
            var _a, _b, _c, _d, _e;
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("header", _hoisted_2, [
                    _cache[16] || (_cache[16] = (0, vue_2.createElementVNode)("div", { class: "mcal-header-text" }, [
                        (0, vue_2.createElementVNode)("h1", null, [
                            (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-calendar" }),
                            (0, vue_2.createTextVNode)(" Calendar")
                        ]),
                        (0, vue_2.createElementVNode)("p", null, "Every caregiver's and patient's booked visits, plus time off & patient unavailability, in one place. Click any event to view details.")
                    ], -1)),
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createElementVNode)("button", {
                            type: "button",
                            class: "mcal-btn ghost",
                            onClick: printCalendar
                        }, __spreadArray([], (_cache[14] || (_cache[14] = [
                            (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-print" }, null, -1),
                            (0, vue_2.createTextVNode)(" Print ", -1)
                        ])), true)),
                        (canAdd.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                key: 0,
                                type: "button",
                                class: "mcal-btn primary",
                                onClick: _cache[0] || (_cache[0] = function ($event) { return (canInteractiveBook.value ? openBookingModalToday() : openScheduler(null)); })
                            }, __spreadArray([], (_cache[15] || (_cache[15] = [
                                (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-plus" }, null, -1),
                                (0, vue_2.createTextVNode)(" New Appointment ", -1)
                            ])), true)))
                            : (0, vue_2.createCommentVNode)("", true)
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_4, [
                    (0, vue_2.createElementVNode)("div", _hoisted_5, [
                        (((_a = access.value) === null || _a === void 0 ? void 0 : _a.kind) === 'admin')
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("section", _hoisted_6, [
                                _cache[20] || (_cache[20] = (0, vue_2.createElementVNode)("div", { class: "mcal-card-head" }, [
                                    (0, vue_2.createElementVNode)("h2", null, [
                                        (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-list-alt" }),
                                        (0, vue_2.createTextVNode)(" My Calendars")
                                    ])
                                ], -1)),
                                (0, vue_2.createElementVNode)("div", _hoisted_7, [
                                    (!selectedOwnerId.value)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 0 }, [
                                            _cache[17] || (_cache[17] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-search mcal-search-icon" }, null, -1)),
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                type: "text",
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((personSearch).value = $event); }),
                                                class: "mcal-search-input",
                                                placeholder: "Search caregivers or patients..."
                                            }, null, 512), [
                                                [vue_2.vModelText, personSearch.value]
                                            ]),
                                            (personSearch.value.trim())
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("ul", _hoisted_8, [
                                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(searchSuggestions.value, function (s) {
                                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", {
                                                            key: s.key
                                                        }, [
                                                            (0, vue_2.createElementVNode)("button", {
                                                                type: "button",
                                                                class: "mcal-suggestion-btn",
                                                                onMousedown: (0, vue_2.withModifiers)(function ($event) { return (pickSuggestion(s)); }, ["prevent"])
                                                            }, [
                                                                (0, vue_2.createElementVNode)("span", {
                                                                    class: "mcal-avatar sm",
                                                                    style: (0, vue_2.normalizeStyle)({ background: colorFor(s.name) })
                                                                }, (0, vue_2.toDisplayString)(initials(s.name)), 5),
                                                                (0, vue_2.createElementVNode)("span", _hoisted_10, [
                                                                    (0, vue_2.createElementVNode)("span", _hoisted_11, (0, vue_2.toDisplayString)(s.name), 1),
                                                                    (0, vue_2.createElementVNode)("span", _hoisted_12, (0, vue_2.toDisplayString)(s.segLabel) + (0, vue_2.toDisplayString)(s.sub ? ' · ' + s.sub : ''), 1)
                                                                ])
                                                            ], 40, _hoisted_9)
                                                        ]));
                                                    }), 128)),
                                                    (searchSuggestions.value.length === 0)
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", _hoisted_13, "No matches found"))
                                                        : (0, vue_2.createCommentVNode)("", true)
                                                ]))
                                                : (0, vue_2.createCommentVNode)("", true)
                                        ], 64))
                                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_14, [
                                            (0, vue_2.createElementVNode)("span", {
                                                class: "mcal-avatar sm",
                                                style: (0, vue_2.normalizeStyle)({ background: colorFor(((_b = selectedOwner.value) === null || _b === void 0 ? void 0 : _b.name) || '') })
                                            }, (0, vue_2.toDisplayString)(initials(((_c = selectedOwner.value) === null || _c === void 0 ? void 0 : _c.name) || '')), 5),
                                            (0, vue_2.createElementVNode)("span", _hoisted_15, (0, vue_2.toDisplayString)((_d = selectedOwner.value) === null || _d === void 0 ? void 0 : _d.name), 1),
                                            (0, vue_2.createElementVNode)("button", {
                                                type: "button",
                                                class: "mcal-chip-x",
                                                "aria-label": "Remove selection",
                                                onClick: clearOwnerSelection
                                            }, __spreadArray([], (_cache[18] || (_cache[18] = [
                                                (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-remove bi-x-lg" }, null, -1)
                                            ])), true))
                                        ]))
                                ]),
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return ((ownerDropdownValue).value = $event); }),
                                    class: "mcal-owner-select",
                                    "aria-label": "Select a caregiver or patient calendar"
                                }, [
                                    _cache[19] || (_cache[19] = (0, vue_2.createElementVNode)("option", { value: "" }, "All calendars", -1)),
                                    ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(ownerSegments, function (seg) {
                                        return (0, vue_2.createElementVNode)("optgroup", {
                                            key: seg.key,
                                            label: seg.label
                                        }, [
                                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(ownersForFiltered(seg.key), function (p) {
                                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                                    key: seg.key + '::' + p.id,
                                                    value: seg.key + '::' + p.id
                                                }, (0, vue_2.toDisplayString)(p.name) + (0, vue_2.toDisplayString)(p.sub ? ' — ' + p.sub : ''), 9, _hoisted_17));
                                            }), 128))
                                        ], 8, _hoisted_16);
                                    }), 64))
                                ], 512), [
                                    [vue_2.vModelSelect, ownerDropdownValue.value]
                                ])
                            ]))
                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("section", _hoisted_18, [
                                _cache[21] || (_cache[21] = (0, vue_2.createElementVNode)("div", { class: "mcal-card-head" }, [
                                    (0, vue_2.createElementVNode)("h2", null, [
                                        (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-list-alt" }),
                                        (0, vue_2.createTextVNode)(" My Calendar")
                                    ])
                                ], -1)),
                                (0, vue_2.createElementVNode)("p", _hoisted_19, [
                                    (0, vue_2.createElementVNode)("strong", null, (0, vue_2.toDisplayString)(ownerDisplayName.value), 1)
                                ])
                            ])),
                        (cardsVisible.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("section", _hoisted_20, [
                                (0, vue_2.createElementVNode)("div", _hoisted_21, [
                                    (0, vue_2.createElementVNode)("h2", null, [
                                        (0, vue_2.createElementVNode)("span", {
                                            class: (0, vue_2.normalizeClass)(["glyphicon", isPatientView.value ? 'glyphicon-ok-circle' : 'glyphicon-ban-circle'])
                                        }, null, 2),
                                        (isPatientView.value)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 0 }, [
                                                (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(ownerDisplayName.value) + " · Available Time", 1)
                                            ], 64))
                                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 1 }, [
                                                (0, vue_2.createTextVNode)("Time Off")
                                            ], 64))
                                    ]),
                                    (!isPatientView.value)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                            key: 0,
                                            type: "button",
                                            class: (0, vue_2.normalizeClass)(["mcal-viewall", { on: showTimeOffOverlay.value }]),
                                            onClick: _cache[3] || (_cache[3] = function ($event) { return (showTimeOffOverlay.value = !showTimeOffOverlay.value); })
                                        }, (0, vue_2.toDisplayString)(showTimeOffOverlay.value ? 'Hide' : 'View All'), 3))
                                        : (0, vue_2.createCommentVNode)("", true)
                                ]),
                                (isPatientView.value)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 0 }, [
                                        _cache[24] || (_cache[24] = (0, vue_2.createElementVNode)("p", { class: "mcal-card-sub" }, "Time slots when the patient is available for visits today.", -1)),
                                        (0, vue_2.createElementVNode)("div", _hoisted_22, [
                                            (patientAvailableToday.value.length === 0)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_23, __spreadArray([], (_cache[22] || (_cache[22] = [
                                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-ban-circle" }, null, -1),
                                                    (0, vue_2.createTextVNode)(" No available time today ", -1)
                                                ])), true)))
                                                : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("ul", _hoisted_24, [
                                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(patientAvailableToday.value, function (s, i) {
                                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", {
                                                            key: 'avail-' + i,
                                                            class: "mcal-timeoff-item"
                                                        }, [
                                                            _cache[23] || (_cache[23] = (0, vue_2.createElementVNode)("span", { class: "mcal-to-cat block" }, "Open", -1)),
                                                            (0, vue_2.createElementVNode)("span", _hoisted_25, [
                                                                (0, vue_2.createElementVNode)("span", _hoisted_26, (0, vue_2.toDisplayString)(fmtTime(s.start)) + " – " + (0, vue_2.toDisplayString)(fmtTime(s.end)), 1)
                                                            ])
                                                        ]));
                                                    }), 128))
                                                ]))
                                        ])
                                    ], 64))
                                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 1 }, [
                                        (0, vue_2.createElementVNode)("p", _hoisted_27, (0, vue_2.toDisplayString)(selectedOwner.value ? "Upcoming time off for ".concat(selectedOwner.value.name) : 'Upcoming time off across the team'), 1),
                                        (0, vue_2.createElementVNode)("div", _hoisted_28, [
                                            (displayedTimeOff.value.length === 0)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_29, __spreadArray([], (_cache[25] || (_cache[25] = [
                                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-ok-circle" }, null, -1),
                                                    (0, vue_2.createTextVNode)(" No upcoming time off ", -1)
                                                ])), true)))
                                                : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("ul", _hoisted_30, [
                                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(displayedTimeOff.value, function (t) {
                                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", {
                                                            key: t.id,
                                                            class: "mcal-timeoff-item"
                                                        }, [
                                                            (0, vue_2.createElementVNode)("span", {
                                                                class: (0, vue_2.normalizeClass)(["mcal-to-cat", t.caregiverCategory])
                                                            }, (0, vue_2.toDisplayString)(shortDate(t.date)), 3),
                                                            (0, vue_2.createElementVNode)("span", _hoisted_31, [
                                                                (0, vue_2.createElementVNode)("span", _hoisted_32, (0, vue_2.toDisplayString)(t.caregiverName), 1),
                                                                (0, vue_2.createElementVNode)("span", _hoisted_33, [
                                                                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(t.allDay ? 'All day' : "".concat(fmtTime(t.startMin), " \u2013 ").concat(fmtTime(t.endMin))), 1),
                                                                    (t.reason)
                                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 0 }, [
                                                                            (0, vue_2.createTextVNode)(" · " + (0, vue_2.toDisplayString)(t.reason), 1)
                                                                        ], 64))
                                                                        : (0, vue_2.createCommentVNode)("", true)
                                                                ])
                                                            ])
                                                        ]));
                                                    }), 128))
                                                ]))
                                        ])
                                    ], 64))
                            ]))
                            : (0, vue_2.createCommentVNode)("", true)
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_34, [
                        (0, vue_2.createElementVNode)("section", _hoisted_35, [
                            (0, vue_2.createElementVNode)("div", _hoisted_36, [
                                (0, vue_2.createElementVNode)("div", _hoisted_37, [
                                    (0, vue_2.createElementVNode)("button", {
                                        type: "button",
                                        class: "mcal-icon-btn",
                                        "aria-label": "Previous",
                                        onClick: _cache[4] || (_cache[4] = function ($event) { return (navigate(-1)); })
                                    }, __spreadArray([], (_cache[26] || (_cache[26] = [
                                        (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-chevron-left bi-chevron-left" }, null, -1)
                                    ])), true)),
                                    (0, vue_2.createElementVNode)("h3", _hoisted_38, (0, vue_2.toDisplayString)(periodLabel.value), 1),
                                    (0, vue_2.createElementVNode)("button", {
                                        type: "button",
                                        class: "mcal-icon-btn",
                                        "aria-label": "Next",
                                        onClick: _cache[5] || (_cache[5] = function ($event) { return (navigate(1)); })
                                    }, __spreadArray([], (_cache[27] || (_cache[27] = [
                                        (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-chevron-right bi-chevron-right" }, null, -1)
                                    ])), true)),
                                    (0, vue_2.createElementVNode)("button", {
                                        type: "button",
                                        class: "mcal-today-btn",
                                        onClick: goToday
                                    }, "Today")
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_39, [
                                    ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(['day', 'week', 'month'], function (v) {
                                        return (0, vue_2.createElementVNode)("button", {
                                            key: v,
                                            type: "button",
                                            class: (0, vue_2.normalizeClass)(["mcal-view-btn", { active: view.value === v }]),
                                            role: "tab",
                                            "aria-selected": view.value === v,
                                            onClick: function ($event) { return (view.value = v); }
                                        }, (0, vue_2.toDisplayString)(v[0].toUpperCase() + v.slice(1)), 11, _hoisted_40);
                                    }), 64))
                                ])
                            ]),
                            (selectedOwner.value)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_41, [
                                    (0, vue_2.createElementVNode)("span", {
                                        class: "mcal-avatar sm",
                                        style: (0, vue_2.normalizeStyle)({ background: colorFor(selectedOwner.value.name) })
                                    }, (0, vue_2.toDisplayString)(initials(selectedOwner.value.name)), 5),
                                    _cache[29] || (_cache[29] = (0, vue_2.createTextVNode)(" Viewing ", -1)),
                                    (0, vue_2.createElementVNode)("strong", null, (0, vue_2.toDisplayString)(selectedOwner.value.name), 1),
                                    (0, vue_2.createElementVNode)("button", {
                                        type: "button",
                                        class: "mcal-clear",
                                        onClick: _cache[6] || (_cache[6] = function ($event) { return (selectedOwnerId.value = ''); })
                                    }, __spreadArray([], (_cache[28] || (_cache[28] = [
                                        (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-remove bi-x-lg" }, null, -1),
                                        (0, vue_2.createTextVNode)(" All calendars ", -1)
                                    ])), true))
                                ]))
                                : (0, vue_2.createCommentVNode)("", true),
                            (view.value === 'month')
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_42, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_43, [
                                        ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(weekdayLabels, function (d) {
                                            return (0, vue_2.createElementVNode)("span", { key: d }, (0, vue_2.toDisplayString)(d), 1);
                                        }), 64))
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_44, [
                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(monthCells.value, function (cell) {
                                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                key: cell.iso,
                                                class: (0, vue_2.normalizeClass)(["mcal-daycell", { out: !cell.inMonth, today: cell.isToday }]),
                                                onClick: function ($event) { return (drillToDay(cell.iso)); }
                                            }, [
                                                (0, vue_2.createElementVNode)("div", _hoisted_46, [
                                                    (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)(cell.dayNum), 1),
                                                    (showTimeOffOverlay.value && cell.timeOff.length)
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", {
                                                            key: 0,
                                                            class: "mcal-off-badge",
                                                            title: cell.timeOff.map(function (t) { return t.caregiverName; }).join(', ')
                                                        }, [
                                                            _cache[30] || (_cache[30] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-ban-circle" }, null, -1)),
                                                            (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(cell.timeOff.length), 1)
                                                        ], 8, _hoisted_47))
                                                        : (0, vue_2.createCommentVNode)("", true)
                                                ]),
                                                (0, vue_2.createElementVNode)("div", _hoisted_48, [
                                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(cell.events.slice(0, 3), function (ev) {
                                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                                            key: ev.id,
                                                            type: "button",
                                                            class: "mcal-chip",
                                                            style: (0, vue_2.normalizeStyle)(eventStyle(ev)),
                                                            onClick: (0, vue_2.withModifiers)(function ($event) { return (openEvent(ev)); }, ["stop"])
                                                        }, [
                                                            (0, vue_2.createElementVNode)("span", _hoisted_50, (0, vue_2.toDisplayString)(fmtTime(ev.startMin)), 1),
                                                            (0, vue_2.createElementVNode)("span", _hoisted_51, (0, vue_2.toDisplayString)(ev.title), 1)
                                                        ], 12, _hoisted_49));
                                                    }), 128)),
                                                    (cell.events.length > 3)
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_52, "+" + (0, vue_2.toDisplayString)(cell.events.length - 3) + " more", 1))
                                                        : (0, vue_2.createCommentVNode)("", true)
                                                ])
                                            ], 10, _hoisted_45));
                                        }), 128))
                                    ])
                                ]))
                                : (view.value === 'week')
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_53, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_54, [
                                            _cache[31] || (_cache[31] = (0, vue_2.createElementVNode)("span", { class: "mcal-tv-corner" }, null, -1)),
                                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(weekDays.value, function (d) {
                                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                                    key: d.iso,
                                                    type: "button",
                                                    class: (0, vue_2.normalizeClass)(["mcal-tv-dayhead", { today: d.isToday }]),
                                                    onClick: function ($event) { return (drillToDay(d.iso)); }
                                                }, [
                                                    (0, vue_2.createElementVNode)("span", _hoisted_56, (0, vue_2.toDisplayString)(d.dow), 1),
                                                    (0, vue_2.createElementVNode)("span", _hoisted_57, (0, vue_2.toDisplayString)(d.dayNum), 1)
                                                ], 10, _hoisted_55));
                                            }), 128))
                                        ]),
                                        (0, vue_2.createElementVNode)("div", _hoisted_58, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_59, [
                                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(hourRange), function (h) {
                                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                        key: h,
                                                        class: "mcal-tv-hour"
                                                    }, [
                                                        (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)(fmtHour(h)), 1)
                                                    ]));
                                                }), 128))
                                            ]),
                                            (0, vue_2.createElementVNode)("div", _hoisted_60, [
                                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(weekDays.value, function (d) {
                                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                        key: d.iso,
                                                        class: (0, vue_2.normalizeClass)(["mcal-tv-col", { today: d.isToday }])
                                                    }, [
                                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(hourRange), function (h) {
                                                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                                key: h,
                                                                class: (0, vue_2.normalizeClass)(["mcal-tv-slot", { bookable: canInteractiveBook.value }]),
                                                                onClick: function ($event) { return (canInteractiveBook.value && openBookingModal(d.iso, h)); }
                                                            }, null, 10, _hoisted_61));
                                                        }), 128)),
                                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(timedTimeOffFor(d.iso), function (t) {
                                                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                                key: t.id,
                                                                class: "mcal-tv-off",
                                                                style: (0, vue_2.normalizeStyle)(blockStyle(t.startMin, t.endMin)),
                                                                title: "".concat(t.caregiverName, " \u2014 ").concat(t.reason)
                                                            }, null, 12, _hoisted_62));
                                                        }), 128)),
                                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(laidOutEventsFor(d.iso), function (item) {
                                                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                                                key: item.ev.id,
                                                                type: "button",
                                                                class: (0, vue_2.normalizeClass)(["mcal-tv-event", { overlap: item.overlap }]),
                                                                style: (0, vue_2.normalizeStyle)([item.style, eventStyle(item.ev)]),
                                                                onClick: function ($event) { return (openEvent(item.ev)); }
                                                            }, [
                                                                (0, vue_2.createElementVNode)("span", _hoisted_64, (0, vue_2.toDisplayString)(item.ev.title), 1),
                                                                (0, vue_2.createElementVNode)("span", _hoisted_65, (0, vue_2.toDisplayString)(fmtTime(item.ev.startMin)), 1)
                                                            ], 14, _hoisted_63));
                                                        }), 128))
                                                    ], 2));
                                                }), 128))
                                            ])
                                        ])
                                    ]))
                                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_66, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_67, [
                                            _cache[32] || (_cache[32] = (0, vue_2.createElementVNode)("span", { class: "mcal-tv-corner" }, null, -1)),
                                            (0, vue_2.createElementVNode)("div", {
                                                class: (0, vue_2.normalizeClass)(["mcal-tv-dayhead single", { today: cursorIso.value === (0, vue_2.unref)(todayIso) }])
                                            }, [
                                                (0, vue_2.createElementVNode)("span", _hoisted_68, (0, vue_2.toDisplayString)(dayHeadLabel.value), 1)
                                            ], 2)
                                        ]),
                                        (0, vue_2.createElementVNode)("div", _hoisted_69, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_70, [
                                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(hourRange), function (h) {
                                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                        key: h,
                                                        class: "mcal-tv-hour"
                                                    }, [
                                                        (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)(fmtHour(h)), 1)
                                                    ]));
                                                }), 128))
                                            ]),
                                            (0, vue_2.createElementVNode)("div", _hoisted_71, [
                                                (0, vue_2.createElementVNode)("div", {
                                                    class: (0, vue_2.normalizeClass)(["mcal-tv-col", { today: cursorIso.value === (0, vue_2.unref)(todayIso) }])
                                                }, [
                                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(hourRange), function (h) {
                                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                            key: h,
                                                            class: (0, vue_2.normalizeClass)(["mcal-tv-slot", { bookable: canInteractiveBook.value }]),
                                                            onClick: function ($event) { return (canInteractiveBook.value && openBookingModal(cursorIso.value, h)); }
                                                        }, null, 10, _hoisted_72));
                                                    }), 128)),
                                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(timedTimeOffFor(cursorIso.value), function (t) {
                                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                            key: t.id,
                                                            class: "mcal-tv-off",
                                                            style: (0, vue_2.normalizeStyle)(blockStyle(t.startMin, t.endMin)),
                                                            title: "".concat(t.caregiverName, " \u2014 ").concat(t.reason)
                                                        }, null, 12, _hoisted_73));
                                                    }), 128)),
                                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(laidOutEventsFor(cursorIso.value), function (item) {
                                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                                            key: item.ev.id,
                                                            type: "button",
                                                            class: (0, vue_2.normalizeClass)(["mcal-tv-event day", { overlap: item.overlap }]),
                                                            style: (0, vue_2.normalizeStyle)([item.style, eventStyle(item.ev)]),
                                                            onClick: function ($event) { return (openEvent(item.ev)); }
                                                        }, [
                                                            (0, vue_2.createElementVNode)("span", _hoisted_75, (0, vue_2.toDisplayString)(item.ev.title), 1),
                                                            (0, vue_2.createElementVNode)("span", _hoisted_76, (0, vue_2.toDisplayString)(fmtTime(item.ev.startMin)) + " – " + (0, vue_2.toDisplayString)(fmtTime(item.ev.endMin)), 1),
                                                            (0, vue_2.createElementVNode)("span", _hoisted_77, [
                                                                (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(item.ev.caregiverName), 1),
                                                                (item.ev.location)
                                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 0 }, [
                                                                        (0, vue_2.createTextVNode)(" · " + (0, vue_2.toDisplayString)(item.ev.location), 1)
                                                                    ], 64))
                                                                    : (0, vue_2.createCommentVNode)("", true)
                                                            ])
                                                        ], 14, _hoisted_74));
                                                    }), 128)),
                                                    (eventsFor(cursorIso.value).length === 0)
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("p", _hoisted_78, "No events scheduled this day"))
                                                        : (0, vue_2.createCommentVNode)("", true)
                                                ], 2)
                                            ])
                                        ])
                                    ])),
                            (0, vue_2.createElementVNode)("div", _hoisted_79, [
                                _cache[34] || (_cache[34] = (0, vue_2.createElementVNode)("span", { class: "mcal-legend-note" }, "Event colors match each caregiver's profile color", -1)),
                                (showTimeOffOverlay.value)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_80, __spreadArray([], (_cache[33] || (_cache[33] = [
                                        (0, vue_2.createElementVNode)("i", { class: "dot off" }, null, -1),
                                        (0, vue_2.createTextVNode)(" Time off", -1)
                                    ])), true)))
                                    : (0, vue_2.createCommentVNode)("", true)
                            ])
                        ])
                    ]),
                    (cardsVisible.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_81, [
                            (0, vue_2.createElementVNode)("section", _hoisted_82, [
                                (0, vue_2.createElementVNode)("div", _hoisted_83, [
                                    (0, vue_2.createElementVNode)("h2", null, "Today · " + (0, vue_2.toDisplayString)(shortDate((0, vue_2.unref)(todayIso))), 1),
                                    (0, vue_2.createElementVNode)("span", _hoisted_84, (0, vue_2.toDisplayString)(todayEvents.value.length) + " events", 1)
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_85, [
                                    (todayEvents.value.length === 0)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_86, __spreadArray([], (_cache[35] || (_cache[35] = [
                                            (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-ok-circle" }, null, -1),
                                            (0, vue_2.createTextVNode)(" Nothing scheduled today ", -1)
                                        ])), true)))
                                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("ul", _hoisted_87, [
                                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(todayEvents.value, function (ev) {
                                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", {
                                                    key: ev.id
                                                }, [
                                                    (0, vue_2.createElementVNode)("button", {
                                                        type: "button",
                                                        class: "mcal-agenda-item",
                                                        style: (0, vue_2.normalizeStyle)(eventStyle(ev)),
                                                        onClick: function ($event) { return (openEvent(ev)); }
                                                    }, [
                                                        (0, vue_2.createElementVNode)("span", _hoisted_89, (0, vue_2.toDisplayString)(fmtTime(ev.startMin)), 1),
                                                        (0, vue_2.createElementVNode)("span", _hoisted_90, [
                                                            (0, vue_2.createElementVNode)("span", _hoisted_91, (0, vue_2.toDisplayString)(ev.title), 1),
                                                            (0, vue_2.createElementVNode)("span", _hoisted_92, [
                                                                _cache[36] || (_cache[36] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-map-marker" }, null, -1)),
                                                                _cache[37] || (_cache[37] = (0, vue_2.createTextVNode)()),
                                                                (isPatientView.value)
                                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 0 }, [
                                                                        (0, vue_2.createTextVNode)("Location: ")
                                                                    ], 64))
                                                                    : (0, vue_2.createCommentVNode)("", true),
                                                                (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(ev.location), 1)
                                                            ])
                                                        ])
                                                    ], 12, _hoisted_88)
                                                ]));
                                            }), 128))
                                        ]))
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("section", _hoisted_93, [
                                _cache[39] || (_cache[39] = (0, vue_2.createElementVNode)("div", { class: "mcal-card-head" }, [
                                    (0, vue_2.createElementVNode)("h2", null, "Upcoming"),
                                    (0, vue_2.createElementVNode)("span", { class: "mcal-pill" }, "Next 10 days")
                                ], -1)),
                                (0, vue_2.createElementVNode)("div", _hoisted_94, [
                                    (upcomingEvents.value.length === 0)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_95, __spreadArray([], (_cache[38] || (_cache[38] = [
                                            (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-info-sign" }, null, -1),
                                            (0, vue_2.createTextVNode)(" No upcoming events ", -1)
                                        ])), true)))
                                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("ul", _hoisted_96, [
                                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(upcomingEvents.value, function (ev) {
                                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", {
                                                    key: ev.id
                                                }, [
                                                    (0, vue_2.createElementVNode)("button", {
                                                        type: "button",
                                                        class: "mcal-agenda-item",
                                                        onClick: function ($event) { return (openEvent(ev)); }
                                                    }, [
                                                        (0, vue_2.createElementVNode)("span", {
                                                            class: "mcal-updot",
                                                            style: (0, vue_2.normalizeStyle)({ background: eventColor(ev) })
                                                        }, null, 4),
                                                        (0, vue_2.createElementVNode)("span", _hoisted_98, [
                                                            (0, vue_2.createElementVNode)("span", _hoisted_99, (0, vue_2.toDisplayString)(relDay(ev.date)), 1),
                                                            (0, vue_2.createElementVNode)("span", _hoisted_100, (0, vue_2.toDisplayString)(ev.title), 1),
                                                            (0, vue_2.createElementVNode)("span", _hoisted_101, [
                                                                (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(fmtTime(ev.startMin)) + " · ", 1),
                                                                (isPatientView.value)
                                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 0 }, [
                                                                        (0, vue_2.createTextVNode)("Location: " + (0, vue_2.toDisplayString)(ev.location), 1)
                                                                    ], 64))
                                                                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 1 }, [
                                                                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(ev.caregiverName), 1)
                                                                    ], 64))
                                                            ])
                                                        ])
                                                    ], 8, _hoisted_97)
                                                ]));
                                            }), 128))
                                        ]))
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("section", _hoisted_102, [
                                (0, vue_2.createElementVNode)("div", _hoisted_103, [
                                    _cache[40] || (_cache[40] = (0, vue_2.createElementVNode)("h2", null, [
                                        (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-transfer" }),
                                        (0, vue_2.createTextVNode)(" Parallel Visits Today")
                                    ], -1)),
                                    (0, vue_2.createElementVNode)("span", _hoisted_104, (0, vue_2.toDisplayString)(parallelVisitsToday.value.length), 1)
                                ]),
                                (0, vue_2.createElementVNode)("p", _hoisted_105, (0, vue_2.toDisplayString)(selectedOwner.value ? "Concurrent visits involving ".concat(selectedOwner.value.name) : 'Every concurrent-visit situation today, practice-wide'), 1),
                                (0, vue_2.createElementVNode)("div", _hoisted_106, [
                                    (parallelVisitsToday.value.length === 0)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_107, __spreadArray([], (_cache[41] || (_cache[41] = [
                                            (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-ok-circle" }, null, -1),
                                            (0, vue_2.createTextVNode)(" No parallel visits today ", -1)
                                        ])), true)))
                                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("ul", _hoisted_108, [
                                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(parallelVisitsToday.value, function (g, gi) {
                                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", {
                                                    key: g.patientId + '-' + gi,
                                                    class: "mcal-parallel-item"
                                                }, [
                                                    (0, vue_2.createElementVNode)("span", _hoisted_109, (0, vue_2.toDisplayString)(g.patientName), 1),
                                                    (0, vue_2.createElementVNode)("ul", _hoisted_110, [
                                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(g.visits, function (v, vi) {
                                                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", {
                                                                key: v.caregiverId + '-' + vi
                                                            }, (0, vue_2.toDisplayString)(fmtTime(v.startMin)) + " – " + (0, vue_2.toDisplayString)(fmtTime(v.endMin)) + " · " + (0, vue_2.toDisplayString)(v.caregiverName), 1));
                                                        }), 128))
                                                    ])
                                                ]));
                                            }), 128))
                                        ]))
                                ])
                            ])
                        ]))
                        : (0, vue_2.createCommentVNode)("", true)
                ]),
                ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(vue_2.Teleport, { to: "body" }, [
                    (0, vue_2.createVNode)(vue_2.Transition, { name: "mcal-modal" }, {
                        default: (0, vue_2.withCtx)(function () { return [
                            (activeEvent.value)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                    key: 0,
                                    class: "mcal-overlay",
                                    onClick: _cache[12] || (_cache[12] = (0, vue_2.withModifiers)(function ($event) { return (closeEvent()); }, ["self"]))
                                }, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_111, [
                                        (0, vue_2.createElementVNode)("div", {
                                            class: "mcal-dialog-head",
                                            style: (0, vue_2.normalizeStyle)({ background: eventColor(activeEvent.value) })
                                        }, [
                                            (0, vue_2.createElementVNode)("span", _hoisted_112, (0, vue_2.toDisplayString)(kindLabel(activeEvent.value.kind)), 1),
                                            (0, vue_2.createElementVNode)("button", {
                                                type: "button",
                                                class: "mcal-close",
                                                "aria-label": "Close",
                                                onClick: _cache[7] || (_cache[7] = function ($event) { return (closeEvent()); })
                                            }, __spreadArray([], (_cache[42] || (_cache[42] = [
                                                (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-remove bi-x-lg" }, null, -1)
                                            ])), true))
                                        ], 4),
                                        (0, vue_2.createElementVNode)("div", _hoisted_113, [
                                            (0, vue_2.createElementVNode)("h3", _hoisted_114, (0, vue_2.toDisplayString)(activeEvent.value.title), 1),
                                            (0, vue_2.createElementVNode)("dl", _hoisted_115, [
                                                (0, vue_2.createElementVNode)("div", null, [
                                                    _cache[43] || (_cache[43] = (0, vue_2.createElementVNode)("dt", null, [
                                                        (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-time" }),
                                                        (0, vue_2.createTextVNode)(" When")
                                                    ], -1)),
                                                    (0, vue_2.createElementVNode)("dd", null, (0, vue_2.toDisplayString)(longDate(activeEvent.value.date)) + ", " + (0, vue_2.toDisplayString)(fmtTime(activeEvent.value.startMin)) + " – " + (0, vue_2.toDisplayString)(fmtTime(activeEvent.value.endMin)), 1)
                                                ]),
                                                (0, vue_2.createElementVNode)("div", null, [
                                                    _cache[44] || (_cache[44] = (0, vue_2.createElementVNode)("dt", null, [
                                                        (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-user" }),
                                                        (0, vue_2.createTextVNode)(" Caregiver")
                                                    ], -1)),
                                                    (0, vue_2.createElementVNode)("dd", null, (0, vue_2.toDisplayString)(activeEvent.value.caregiverName), 1)
                                                ]),
                                                (activeEvent.value.patientName && !isPatientView.value)
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_116, [
                                                        _cache[45] || (_cache[45] = (0, vue_2.createElementVNode)("dt", null, [
                                                            (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-heart" }),
                                                            (0, vue_2.createTextVNode)(" Patient")
                                                        ], -1)),
                                                        (0, vue_2.createElementVNode)("dd", null, (0, vue_2.toDisplayString)(activeEvent.value.patientName), 1)
                                                    ]))
                                                    : (0, vue_2.createCommentVNode)("", true),
                                                (0, vue_2.createElementVNode)("div", null, [
                                                    _cache[46] || (_cache[46] = (0, vue_2.createElementVNode)("dt", null, [
                                                        (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-map-marker" }),
                                                        (0, vue_2.createTextVNode)(" Location")
                                                    ], -1)),
                                                    (0, vue_2.createElementVNode)("dd", null, (0, vue_2.toDisplayString)(activeEvent.value.location), 1)
                                                ]),
                                                (activeEvent.value.reason)
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_117, [
                                                        _cache[47] || (_cache[47] = (0, vue_2.createElementVNode)("dt", null, [
                                                            (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-info-sign" }),
                                                            (0, vue_2.createTextVNode)(" Reason")
                                                        ], -1)),
                                                        (0, vue_2.createElementVNode)("dd", null, (0, vue_2.toDisplayString)(activeEvent.value.reason), 1)
                                                    ]))
                                                    : (0, vue_2.createCommentVNode)("", true)
                                            ])
                                        ]),
                                        (0, vue_2.createElementVNode)("div", _hoisted_118, [
                                            (0, vue_2.createElementVNode)("button", {
                                                type: "button",
                                                class: "mcal-btn ghost",
                                                onClick: _cache[8] || (_cache[8] = function ($event) { return (closeEvent()); })
                                            }, "Close"),
                                            (canInteractiveBook.value)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 0 }, [
                                                    (0, vue_2.createElementVNode)("button", {
                                                        type: "button",
                                                        class: "mcal-btn danger",
                                                        disabled: cancellingVisit.value,
                                                        onClick: _cache[9] || (_cache[9] = function ($event) { return (cancelActiveVisit()); })
                                                    }, __spreadArray([], (_cache[48] || (_cache[48] = [
                                                        (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-trash" }, null, -1),
                                                        (0, vue_2.createTextVNode)(" Cancel Visit ", -1)
                                                    ])), true), 8, _hoisted_119),
                                                    (0, vue_2.createElementVNode)("button", {
                                                        type: "button",
                                                        class: "mcal-btn primary",
                                                        onClick: _cache[10] || (_cache[10] = function ($event) { return (startReschedule(activeEvent.value)); })
                                                    }, __spreadArray([], (_cache[49] || (_cache[49] = [
                                                        (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-repeat" }, null, -1),
                                                        (0, vue_2.createTextVNode)(" Reschedule ", -1)
                                                    ])), true))
                                                ], 64))
                                                : (canAdd.value)
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                                        key: 1,
                                                        type: "button",
                                                        class: "mcal-btn primary",
                                                        onClick: _cache[11] || (_cache[11] = function ($event) { return (editInScheduler(activeEvent.value)); })
                                                    }, __spreadArray([], (_cache[50] || (_cache[50] = [
                                                        (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-pencil" }, null, -1),
                                                        (0, vue_2.createTextVNode)(" Edit in Scheduler ", -1)
                                                    ])), true)))
                                                    : (0, vue_2.createCommentVNode)("", true)
                                        ])
                                    ])
                                ]))
                                : (0, vue_2.createCommentVNode)("", true)
                        ]; }, undefined, true),
                        _: 1
                    })
                ])),
                (bookingModalOpen.value && ((_e = props.access) === null || _e === void 0 ? void 0 : _e.kind) === 'patient')
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(MasterCalendarBookingModal_vue_1.default, {
                        key: 0,
                        accountnumber: props.accountnumber,
                        "patient-id": props.access.patientId,
                        "patient-name": props.access.patientName,
                        "initial-date": bookingModalDate.value,
                        "initial-time": bookingModalTime.value,
                        "edit-event": editingEvent.value,
                        onClose: _cache[13] || (_cache[13] = function ($event) { return (bookingModalOpen.value = false); }),
                        onSaved: onVisitSaved
                    }, null, 8, ["accountnumber", "patient-id", "patient-name", "initial-date", "initial-time", "edit-event"]))
                    : (0, vue_2.createCommentVNode)("", true)
            ]));
        };
    }
});
